import React from 'react';
import ApartmentCarousel from "./ApartmentCarousel";
import ApartmentIcons from "./ApartmentIcons";
import ApartmentPrice from "./ApartmentPrice";
import Rating from "./Rating";
import ApartmentLike from "./ApartmentLike";
import '@assets/sass/components/apartment-box.scss';
import LinkButton from "./Buttons/LinkButton";

const getApartmentsCity = (city, translations) => {
    switch (city) {
        case 'Kołobrzeg':
            return translations['kolobrzeg'] || city
        case 'Świnoujście':
            return translations['swinoujscie'];
        case 'Mielno':
            return translations['mielno'];
        case 'Ustronie Morskie':
            return translations['ustronie-morskie'];
        case 'Sianożęty':
            return translations['sianozety'];
        case 'Szklarska Poręba':
            return translations["szklarska-poreba"];
    }

    return city;
}

const getApartmentTitle = (title, translations) => {
    return title.replace('Apartament', translations['apartment'])
}

const getCarousel = (carousel, apartment, apartmentUrl) => {
    if (carousel) {
        return <ApartmentCarousel apartment={apartment} href={apartmentUrl}>
            <ApartmentLike active={apartment.favourite} apartmentId={apartment.id} key={'like-' + apartment.id}/>
            {apartment.rate && <Rating rate={apartment.rate}/>}
        </ApartmentCarousel>
    }
    return <div>
        <a className="apartment-photos-carousel__photo" href={apartmentUrl} target="_blank" style={{cursor: "default"}}>
            <img
                src={apartment.photos[0]}
                alt={apartment.title}
                width="283"
                height="178"
                loading="lazy"
                // onLoad={this.handleLoad}
            />
        </a>
        {/*<img src={apartment.photos[0]} alt={apartment.title}/>*/}
        <ApartmentLike active={apartment.favourite} apartmentId={apartment.id} key={'like-' + apartment.id}/>
    </div>
}

export default ({apartment, translations, apartmentUrl, carousel, additionalClass}) => {
    return (
        <div className={'apartment-box ' + additionalClass }>
            <article id={'apartment_' + apartment.id}>
                <div className="apartment-box__item apartment-photos">
                    {apartment.discount_label &&
                        <small
                            dangerouslySetInnerHTML={{__html: apartment.discount_label.label}}
                            className={`discount-label discount-label--${apartment.discount_label.slug}`}
                        />}
                    {getCarousel(carousel, apartment, apartmentUrl)}
                </div>
                <div className="apartment-box__item apartment-details">
                    <div className="apartment-details__row">
                        <div className="apartment-city">{getApartmentsCity(apartment.city, translations)}</div>
                    </div>
                    <div className="apartment-details__row">
                        <header className="apartment-title">
                            <a target="_blank" href={apartmentUrl}>
                                <h3>{getApartmentTitle(apartment.title, translations)}</h3>
                            </a>
                        </header>
                    </div>
                    <div className="apartment-details__row">
                        <ApartmentIcons translations={translations} apartment={apartment}/>
                    </div>
                    <div className="apartment-details__row apartment-details__row--sectional-2">
                        <ApartmentPrice apartment={apartment} translations={translations}/>
                        <div className="apartment-book">
                            <LinkButton href={apartmentUrl} content={translations['book']}/>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    )
}
